<template>
  <div class="Printmaking">

    <!-- Masthead -->
    <SurveyMasthead
      title="Other Mediums"
      subtitle="Printmaking &amp; Drawing."
      srcImage="/assets/other/painting/mast-icon-easel-140.png"
      largeImage="/assets/other/painting/mast-icon-easel-280.png"
      :srcSize="140"
      bgColour="#00A2CB" />


    <!-- Project Details -->
    <div class="details">

      <!-- Neon -->
      <ContentSection title="Printmaking" :centered="true">
        <p>Printmaking often occupies the position as a foil to my painting; exploring different aspects of paintings in progress and revealing new directions and ideas.</p>

        <ProjectImage
          srcImage="/assets/other/mediums/litho-collage-900.jpg"
          largeImage="/assets/other/mediums/litho-collage-1800.jpg"
          caption="Lithograph; 24 x 20 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/litho-multi-900.jpg"
          largeImage="/assets/other/mediums/litho-multi-1800.jpg"
          caption="Lithograph; 24 x 20 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/litho-silo-900.jpg"
          largeImage="/assets/other/mediums/litho-silo-1800.jpg"
          caption="Lithograph; 24 x 16 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/litho-dyptych-500.jpg"
          largeImage="/assets/other/mediums/litho-dyptych-1800.jpg"
          caption="Lithograph; 20 x 20 inches"
          :srcSize="500"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/aquatint-trees-900.jpg"
          largeImage="/assets/other/mediums/aquatint-trees-1800.jpg"
          caption="Aquatint; 18 x 14 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/etching-barn-900.jpg"
          largeImage="/assets/other/mediums/etching-barn-1800.jpg"
          caption="Etching; 18 x 14 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/lino-trees-500.jpg"
          largeImage="/assets/other/mediums/lino-trees-1800.jpg"
          caption="Linocut; 18 x 18 inches"
          :srcSize="500"
          :canZoom="true" />
      </ContentSection> 

      <!-- Other -->
      <ContentSection title="Drawing" :centered="true">
        <p>Often the foundation of work that follows, my drawings are often the rough draft for future, final work.</p>

        <ProjectImage
          srcImage="/assets/other/mediums/pastel-quadrants-900.jpg"
          largeImage="/assets/other/mediums/pastel-quadrants-1800.jpg"
          caption="Chalk pastel on paper; 34 x 24 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/pastel-barn-900.jpg"
          largeImage="/assets/other/mediums/pastel-barn-1800.jpg"
          caption="Chalk pastel on paper; 34 x 24 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/ink-barns-900.jpg"
          largeImage="/assets/other/mediums/ink-barns-1800.jpg"
          caption="Ink on paper; 38 x 24 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/sketch-silo-900.jpg"
          largeImage="/assets/other/mediums/sketch-silo-1800.jpg"
          caption="Graphite on paper; 32 x 22 inches"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/sketch-barn-500.jpg"
          largeImage="/assets/other/mediums/sketch-barn-1800.jpg"
          caption="Graphite on paper; 16 x 18 inches"
          :srcSize="500"
          :canZoom="true" />

        <ProjectImage
          srcImage="/assets/other/mediums/sketch-roof-500.jpg"
          largeImage="/assets/other/mediums/sketch-roof-1800.jpg"
          caption="Graphite on paper; 16 x 19 inches"
          :srcSize="500"
          :canZoom="true" />
      
      </ContentSection> 
  

    </div>

    <Pagination
      prevLabel="Architecture"
      nextLabel="Game Design"
      prevRoute="Architecture"
      nextRoute="Game" />

    <Footer />
  </div>
</template>

<script>
import SurveyMasthead from '@/components/SurveyMasthead.vue'
import Footer from '@/components/Footer.vue'
import Pagination from '@/components/Pagination.vue'
import ContentSection from '@/components/ContentSection.vue'
import ProjectImage from '@/components/ProjectImage.vue'

export default {
  name: 'Printmaking',
  components: {
    SurveyMasthead,
    Footer,
    Pagination,
    ContentSection,
    ProjectImage
  },
}
</script>

<style lang="scss" scoped>
  .Printmaking {
    background: #fff;
  }
</style>
